var _a, _b;
import { flagNames } from '../../feature-flags/flags';
export var FS_FEATURES = {
    CALENDAR: 'calendar',
    CLIENTS: 'clients',
    REGISTER: 'register',
};
export var FLAG_NAME_BY_FEATURE = (_a = {},
    _a[FS_FEATURES.CALENDAR] = flagNames.FULLSTORY_CALENDAR_FLOW,
    _a[FS_FEATURES.CLIENTS] = flagNames.FULLSTORY_CLIENTS_FLOW,
    _a[FS_FEATURES.REGISTER] = flagNames.FULLSTORY_REGISTER_FLOW,
    _a);
export var getFlagValueForFeature = function (feature, flags) {
    return flags[FLAG_NAME_BY_FEATURE[feature]];
};
export var RECORDING_STARTED_MESSAGE_BY_FEATURE = (_b = {},
    _b[FS_FEATURES.CALENDAR] = 'Recording Started - Calendar Flow',
    _b[FS_FEATURES.CLIENTS] = 'Recording Started - Clients Flow',
    _b[FS_FEATURES.REGISTER] = 'Recording Started - Register Flow',
    _b);
